/**
 * 処分業者
 */
import Vue from 'vue'
import * as httpConst from '../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/tenant/user_registration_decision`

const user_registration_decision = {
  namespaced: true,
  actions: {
    show () {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default user_registration_decision
